angular.module('account', ['core', 'auth', 'account.login', 'account.password-reset', 'account.settings', 'account.access-denied'])
    .factory('Account', function ($resource) {
        return $resource('/crm/api/account/', {}, {
            resetRequest: {url: '/crm/api/account/reset', method: 'POST'},
            resetFinish: {url: '/crm/api/account/reset/finish', method: 'POST'},
            passwordChange: {url: '/crm/api/account/password-change', method: 'POST'},
            update: {method: 'PUT'},
            language: {method: 'GET'},
            groups: {method: 'GET', 'url': '/crm/api/account/groups', isArray: true},
            avatarRemove: {method: 'DELETE', url: '/crm/api/account/avatar-remove'},
            currentAccount: {url: '/crm/api/account/current-account'},
            safeZoneSuperAdmin: {url: '/crm/api/account/safe-zone-super-admin'}
        });
    })
    .factory('ICalendar', function ($resource) {
        return $resource('/crm/api/ical', {}, {
            regenerate: {method: 'POST', 'url': '/crm/api/ical/regenerate'}
        });
    })
    .factory('SharedCalendarSettings', function ($resource) {
        return $resource('/crm/api/shared-calendar/settings', {}, {
            update: {method: 'PUT'}
        });
    })
    .factory('PasswordStrengthService', function () {
        var requiredRules = ['minLength', 'maxLength', 'lowercase', 'uppercase', 'digit', 'special'];
        var levels = {
            empty: 0,
            weak: 25,
            medium: 55,
            good: 78,
            strong: 100
        };

        var resolveLevel = function (level) {
            return {level: level, value: levels[level]};
        };

        var resolveChecks = function (password) {
            return {
                minLength: password.length >= 8,
                recommendedLength: password.length >= 12,
                maxLength: password.length > 0 && password.length <= 120,
                lowercase: /[a-z]/.test(password),
                uppercase: /[A-Z]/.test(password),
                digit: /\d/.test(password),
                special: /[^A-Za-z0-9]/.test(password)
            };
        };

        var resolveScore = function (checks) {
            return [
                checks.minLength,
                checks.recommendedLength,
                checks.lowercase,
                checks.uppercase,
                checks.digit,
                checks.special
            ].filter(Boolean).length;
        };

        return {
            evaluate: function (password) {
                if (!angular.isString(password) || password.length === 0) {
                    return resolveLevel('empty');
                }

                var score = resolveScore(resolveChecks(password));
                if (score <= 2) {
                    return resolveLevel('weak');
                }
                if (score <= 4) {
                    return resolveLevel('medium');
                }
                if (score <= 5) {
                    return resolveLevel('good');
                }
                return resolveLevel('strong');
            },
            isValid: function (password) {
                if (!angular.isString(password)) {
                    return false;
                }
                var checks = resolveChecks(password);
                return requiredRules.every(function (rule) {
                    return checks[rule];
                });
            },
            getRequirements: function (password) {
                var checks = resolveChecks(angular.isString(password) ? password : '');
                return requiredRules.map(function (rule) {
                    return {key: rule, met: checks[rule]};
                });
            }
        };
    })
    .directive('passwordRequirements', function (PasswordStrengthService) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$validators.passwordRequirements = function (modelValue, viewValue) {
                    return PasswordStrengthService.isValid(modelValue || viewValue);
                };
            }
        };
    })
    .directive('passwordMatch', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$validators.passwordMatch = function (modelValue, viewValue) {
                    var value = modelValue || viewValue;
                    return ngModel.$isEmpty(value) || value === scope.$eval(attrs.passwordMatch);
                };
                scope.$watch(attrs.passwordMatch, function () {
                    ngModel.$validate();
                });
            }
        };
    })
    .component('passwordStrengthMeter', {
        bindings: {
            password: '<'
        },
        template: '<div class="password-strength"><div class="password-strength__header"><span translate="password-strength.label"></span><strong aria-live="polite">{{\'password-strength.level.\' + $ctrl.strength.level | translate}}</strong></div><div class="password-strength__track" role="progressbar" aria-label="{{\'password-strength.label\' | translate}}" aria-valuemin="0" aria-valuemax="100" aria-valuenow="{{$ctrl.strength.value}}" aria-valuetext="{{\'password-strength.level.\' + $ctrl.strength.level | translate}}"><span class="password-strength__bar password-strength__bar--{{$ctrl.strength.level}}"></span></div><ul class="password-strength__requirements" aria-label="{{\'password-strength.requirements\' | translate}}"><li ng-repeat="requirement in $ctrl.requirements track by requirement.key" ng-class="{\'is-met\': requirement.met}"><i class="fa" ng-class="requirement.met ? \'fa-check-circle\' : \'fa-circle-o\'" aria-hidden="true"></i><span>{{\'password-strength.requirement.\' + requirement.key | translate}}</span><span class="sr-only"> — {{(requirement.met ? \'password-strength.requirement.met\' : \'password-strength.requirement.not-met\') | translate}}</span></li></ul></div>',
        controller: function (PasswordStrengthService) {
            var controller = this;
            this.$onChanges = function () {
                controller.strength = PasswordStrengthService.evaluate(controller.password);
                controller.requirements = PasswordStrengthService.getRequirements(controller.password);
            };
        }
    })
    .component('passwordMatchStatus', {
        bindings: {
            password: '<',
            confirmationPassword: '<'
        },
        template: '<span class="password-match-status" ng-if="$ctrl.visible" ng-class="$ctrl.matches ? \'is-match\' : \'is-mismatch\'" role="status" aria-live="polite"><i class="fa" ng-class="$ctrl.matches ? \'fa-check-circle\' : \'fa-times-circle\'" aria-hidden="true"></i>{{($ctrl.matches ? \'password-strength.passwords-match\' : \'password-strength.passwords-not-match\') | translate}}</span>',
        controller: function () {
            var controller = this;
            this.$onChanges = function () {
                controller.visible = angular.isString(controller.confirmationPassword) && controller.confirmationPassword.length > 0;
                controller.matches = controller.visible && angular.isString(controller.password) && controller.password === controller.confirmationPassword;
            };
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('unauthenticated', {
            abstract: true,
            resolve: {
                bodyStyleUnauthenticated: function ($rootScope) {
                    $rootScope.globalUserUnauthenticated = true;
                }
            }
        });
    });
